import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckRanAvailableTemplate } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithIdName } from '@utils/formatter';

import { IId, TIdName  } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_RAN_GET_AVAILABLE_TEMPLATES } from '@constants/queryKeys';

interface IUseQueryConsistencyCheckRanGetAvailableTemplate {
	availableTemplates: TSelectOption<string>[];
	isLoadingAvailableTemplates: boolean;
}

const useQueryConsistencyCheckRanGetAvailableTemplate = ({
	id,
}: Partial<IId>): IUseQueryConsistencyCheckRanGetAvailableTemplate => {
	const {
		data,
		isInitialLoading,
	} = useQuery<TIdName[], TSelectOption<string>[]>({
		queryKey: [CONSISTENCY_RAN_GET_AVAILABLE_TEMPLATES, { id }],
		queryFn: extractQueryParams(getConsistencyCheckRanAvailableTemplate),
		select: (data) => optionsFormattedWithIdName(data),
		enabled: [!!id],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		availableTemplates: data || [],
		isLoadingAvailableTemplates: isInitialLoading,
	};
};

export default useQueryConsistencyCheckRanGetAvailableTemplate;
